function hk_items_Reducer(state = [], action) {
    switch (action.type) {
        case 'HK_ITEMS/SET':
            return action.items;
        case 'HK_ITEMS/CLEAR':
            return [];
        default:
            return state;
    }
}

export default hk_items_Reducer;
